import React, { useState } from "react";
import { Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

const AV = ["bg-sky-500", "bg-emerald-500", "bg-amber-500", "bg-rose-500", "bg-violet-500", "bg-teal-500", "bg-indigo-500", "bg-orange-500"];
const hash = (s) => [...(s || "")].reduce((a, c) => (a * 31 + c.charCodeAt(0)) >>> 0, 7);
export const initials = (name) => (name || "?").replace(/@.*/, "").split(/[\s._-]+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("") || "?";

export function Avatar({ email, name, size = "w-8 h-8 text-xs" }) {
  return (
    <span className={`${size} ${AV[hash(email) % AV.length]} rounded-full inline-flex items-center justify-center text-white font-semibold flex-shrink-0`} title={name || email}>
      {initials(name || email)}
    </span>
  );
}

export function TicketMembers({ ticket, basePath, users, onChange }) {
  const members = ticket.members || [];
  const nameOf = (e) => users.find((u) => u.email === e)?.name || e;
  const toggle = async (email) => {
    const next = members.includes(email) ? members.filter((m) => m !== email) : [...members, email];
    try {
      await api.put(`${basePath}/${ticket.id}/members`, { emails: next });
      onChange();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur");
    }
  };
  return (
    <div data-testid="trello-members">
      <div className="text-xs font-semibold text-norea-textMuted mb-1.5">Membres</div>
      <div className="flex items-center gap-1.5 flex-wrap">
        {members.map((m) => <Avatar key={m} email={m} name={nameOf(m)} />)}
        <Popover>
          <PopoverTrigger asChild>
            <button className="w-8 h-8 rounded-full bg-norea-surfaceHover hover:bg-norea-border inline-flex items-center justify-center transition-colors" title="Ajouter un membre" data-testid="trello-members-add">
              <Plus className="w-4 h-4" />
            </button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-72 p-2 max-h-80 overflow-y-auto" data-testid="trello-members-picker">
            <div className="text-[10px] uppercase tracking-wider font-semibold text-norea-textMuted px-1 mb-1">Membres de l'équipe</div>
            {users.map((u) => (
              <button key={u.email} onClick={() => toggle(u.email)} className="w-full flex items-center gap-2 px-1.5 py-1.5 rounded hover:bg-norea-surfaceHover text-left" data-testid={`trello-member-option-${u.email}`}>
                <Avatar email={u.email} name={u.name} size="w-6 h-6 text-[10px]" />
                <span className="flex-1 min-w-0 text-sm truncate">{u.name}</span>
                {members.includes(u.email) && <Check className="w-4 h-4 text-norea-primary" />}
              </button>
            ))}
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
}
